module.exports = __webpack_public_path__ + "static/media/usdot.9cbd3298.svg";